<router-outlet></router-outlet>
<!-- <app-full-loader></app-full-loader> -->